"use client";

import { useActionState } from "react";
import Link from "next/link";
import { loginAction } from "../actions";
import { Button } from "@/components/ui/button";
import { FormField, Input } from "@/components/ui/input";

export function LoginForm({ tenantHint, next }: { tenantHint?: string; next?: string }) {
  const [state, formAction, pending] = useActionState(loginAction, undefined);

  return (
    <form action={formAction} className="space-y-4">
      {tenantHint ? (
        <p className="rounded-lg bg-navy-50 px-3 py-2 text-sm text-navy-700">
          Sign in to access <span className="font-semibold">{tenantHint}</span>&apos;s workspace.
        </p>
      ) : null}
      <input type="hidden" name="next" value={next ?? "/dashboard"} />
      <FormField label="Work email" htmlFor="email">
        <Input id="email" name="email" type="email" autoComplete="email" required placeholder="you@company.com" />
      </FormField>
      <FormField label="Password" htmlFor="password">
        <Input id="password" name="password" type="password" autoComplete="current-password" required />
      </FormField>
      {state?.error ? (
        <p className="text-sm text-status-danger" role="alert">
          {state.error}
        </p>
      ) : null}
      <Button type="submit" className="w-full" disabled={pending}>
        {pending ? "Signing in…" : "Sign in"}
      </Button>
      <p className="text-center text-sm text-slate-500">
        New to Praxis42 Safety Hub?{" "}
        <Link href="/signup" className="font-medium text-brand-orange hover:underline">
          Start your free trial
        </Link>
      </p>
    </form>
  );
}
